export const getToken = () => localStorage.getItem("token");
export const getRole = () => localStorage.getItem("role");
export const getEmail = () => localStorage.getItem("email");
export const getMobile = () => localStorage.getItem("mobile");
export const getId = () => localStorage.getItem("id");
export const setAuth = (token, role, email, mobile, id) => {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  localStorage.setItem("email", email);
  localStorage.setItem("mobile", mobile);
  localStorage.setItem("id", id);
};
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("email");
  localStorage.removeItem("mobile");
  localStorage.removeItem("id");
};
export function removeAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("email");
  localStorage.removeItem("mobile");
  localStorage.removeItem("id");
}
